import { useQuery } from '@tanstack/react-query'

export interface School {
  id: string
  name: string
  district?: {
    id: string
    name: string
  }
}

const API_URL =
  import.meta.env.VITE_EPC_API_URL ?? import.meta.env.REACT_APP_API_URL ?? ''

/**
 * Hook for fetching schools from a public endpoint without authentication
 * Used for the signup form where users aren't authenticated yet
 */
export const usePublicSchools = (districtId?: string) => {
  return useQuery({
    queryKey: ['public-schools', { districtId }],
    queryFn: async () => {
      if (!districtId) {
        return []
      }

      try {
        // Try the public endpoint first
        const params = new URLSearchParams({ district: districtId })
        const publicUrl = `${API_URL}/schools?${params}`

        const publicResponse = await fetch(publicUrl)

        if (publicResponse.ok) {
          return publicResponse.json() as Promise<School[]>
        }
        return [] as School[]
      } catch (error) {
        console.error('Error fetching schools:', error)
        return []
      }
    },
    enabled: !!districtId,
  })
}
